
import { JSX } from 'react';
import './PageContainer.css'

//interface ContainerProps<T> {
//    data: T;
//}
//
//const PageContainer = <T,>({ data }: ContainerProps<T>) => {
//    return <div className="PageContainer">{JSON.stringify(data)}</div>;
//};

const PageContainer = (data: JSX.Element) => {
  return <div className="PageContainer">
    {data}
  </div>;
};

export default PageContainer